import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash';
import { DateTime } from 'luxon';
import { UpdatedSetupSummary } from '../../../../models/setup/setup.models';
import { CurrentDayService } from '../../../../services/date/current-day.service';
import { ValidationResult } from '../../../../models/projects/validation.models';

export interface DailyLogHeaderSnapshot {
  dateKey: string;
  displayDate: string;
  summary: UpdatedSetupSummary;
}

// A display-only snapshot shared across page instances. Parents always refresh
// their own data and retain control of loading, permissions and navigation.
@Injectable({ providedIn: 'root' })
export class DailyLogSummaryHeaderStateService {
  private snapshot: DailyLogHeaderSnapshot;
  private activeDayActionVisible = false;
  private validationSnapshot: { dateKey: string; result: ValidationResult };

  constructor(private currentDayService: CurrentDayService) {}

  getForCurrentDay(): DailyLogHeaderSnapshot {
    const dateKey = this.currentDayService.getCurrentLogDayFromLocalStorage();
    return this.snapshot && this.snapshot.dateKey === dateKey ? this.snapshot : null;
  }

  getActiveDayAction(): boolean {
    return this.activeDayActionVisible;
  }

  getValidationForCurrentDay(): ValidationResult {
    return this.validationSnapshot?.dateKey === this.currentDayService.getCurrentLogDayFromLocalStorage()
      ? cloneDeep(this.validationSnapshot.result) : null;
  }

  rememberValidation(date: DateTime, result: ValidationResult) {
    const dateKey = date.toUTC().toISO();
    if (dateKey === this.currentDayService.getCurrentLogDayFromLocalStorage()) {
      this.validationSnapshot = { dateKey, result: cloneDeep(result) };
    }
  }

  rememberActiveDayAction(visible: boolean) {
    // This is the last verified display state, independent of the summary and
    // of temporary storage/date changes while the next page is loading.
    this.activeDayActionVisible = visible;
  }

  remember(date: DateTime, displayDate: string, summary: UpdatedSetupSummary) {
    const dateKey = date.toUTC().toISO();
    if (dateKey !== this.currentDayService.getCurrentLogDayFromLocalStorage()) {
      return;
    }
    this.snapshot = { dateKey, displayDate, summary: cloneDeep(summary) };
  }
}



// WEBPACK FOOTER //
// ./src/pages/shared/components/daily-log-summary-header/daily-log-summary-header-state.service.ts